<div class="row">
    <div class="col-md-2"></div>
    <div class="col-md-8">
        <div class="card" style="border: 1px solid rgba(0,0,0,.125);border-radius: .25rem;">
            <div class="card-body">
                <div class="bg-default w-100  text-center mb-3">
                    <h2 class="card-title">
                        DATOS DEL SOLICITANTE</h2>
                </div>


                <form class="px-3" id="contact-form" ngNativeValidate #f="ngForm"
                    (ngSubmit)="agregar(modalnotification)">

                    <div class="bg-default w-100  text-center mb-3">
                        <h2 class="text-white">DATOS DEL SOLICITANTE</h2>
                    </div>

                  
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Nombre</h6>
                        <input type="text" class="form-control" name="nombre" [(ngModel)]="forma.nombre"
                            placeholder="Escribe tu nombre..." required maxlength="80" appNomultispaces textOnly>
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Apellido Paterno</h6>
                        <input type="text" class="form-control" name="apellido_paterno"
                            [(ngModel)]="forma.apellido_paterno" placeholder="Escribe tu apellido paterno..." required
                            maxlength="80" appNomultispaces textOnly>
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Apellido Materno</h6>
                        <input type="text" class="form-control" name="apellido_materno"
                            [(ngModel)]="forma.apellido_materno" placeholder="Escribe tu apellido materno..." required
                            maxlength="80" appNomultispaces textOnly>
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Teléfono</h6>
                        <input aria-label="Telefono" name="telefono" [(ngModel)]="forma.telefono" class="form-control"
                            placeholder="Escribe tu teléfono..." type="text" mask="(000) 000 0000"
                            [dropSpecialCharacters]="false" required />
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Email</h6>
                        <input type="email" class="form-control" [(ngModel)]="forma.email" name="email"
                            placeholder="Escribe tu correo electronico..." required maxlength="90"
                            (focusout)="validarEmail()" aria-label="correo" />
                    </div>
                    <div class="w-100  text-center mb-2">
                        <h5>UBICACIÓN DEL REPORTE</h5>
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Calle</h6>
                        <input aria-label="calle" [(ngModel)]="forma.calle" name="calle" class="form-control"
                            placeholder="Escribe la calle..." type="text" required maxlength="120" appNomultispaces />
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Número</h6>
                        <input aria-label="número" [(ngModel)]="forma.numero" name="numero" class="form-control"
                            placeholder="Escribe el número..." type="text" required maxlength="20" appNomultispaces />
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Entre Calle 1</h6>
                        <input aria-label="entre calle 1" [(ngModel)]="forma.entre_calle_1" name="entre_calle_1"
                            class="form-control" placeholder="Escribe la entre calle..." type="text" required
                            maxlength="120" appNomultispaces />
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Entre Calle 2</h6>
                        <input aria-label="entre calle 2" [(ngModel)]="forma.entre_calle_2" name="entre_calle_2"
                            class="form-control" placeholder="Escribe la entre calle..." type="text" required
                            maxlength="120" appNomultispaces />
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Servicio</h6>
                        <select class="form-control" [(ngModel)]="forma.IdServicio" name="IdServicio">
                            <option *ngFor="let item of servicios" value="{{item.IdServicio}}">
                                {{item.Servicio}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group mb-4">
                        <h6 class="card-subtitle mb-2">Colonia</h6>
                        <!-- <ng-select class="custom-class" aria-label="Tipo..." [items]="colonias" bindLabel="Colonia" bindValue="Idcolonia"
                                        [(ngModel)]="forma.Idcolonia" name="idServicio" [required]>
                                    </ng-select>-->
                        <select class="form-control" [(ngModel)]="forma.Idcolonia" name="Idcolonia">
                            <option *ngFor="let item of colonias" value="{{item.Idcolonia}}">
                                {{item.Colonia}}
                            </option>
                        </select>
                    </div>
                    <div class="bg-default w-100  text-center">
                        <h5 class="text-white">COMENTARIOS</h5>
                    </div>
                    <div class="form-group">
                        <label> A continuación redacte su solicitud de manera clara y concisa, tratando de no
                            omitir ningún dato que considere relevante para poder atender su petición.</label>
                        <textarea aria-label="comentarios" class="form-control form-control-alternative"
                            [(ngModel)]="forma.comentarios" name="comentarios" id="message" name="message" rows="6"
                            required></textarea>
                    </div>

                  


               
                    <div class="row " align="right">
                        <!--[disabled]="!f.valid || !captcha" -->
                        <div class="col-12 col-md-12">
                            <button class="btn btn-primary pull-right "  type="submit"
                                data-target="#modal-notification">
                                <span> <i class="fas fa-plus"></i> Agregar</span>
                                <i class='fa fa-sync fa-spin' *ngIf="loading"></i>
                            </button>
                        </div>
                    </div>
                    
          
                  
                </form>
            </div>
        </div>
    </div>
    <div class="col-md-2"></div>

</div>
<div aria-hidden="true" aria-labelledby="modal-notification" bsModal class="modal fade" #modalnotification="bs-modal"
    id="modal-notification" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-danger modal-dialog-centered modal-" role="document">
        <div class="modal-content bg-gradient-info">
            <div class="modal-header">
                <h6 class="modal-title text-uppercase" id="modal-title-notification">
                    Solicitud registrada con éxito.
                </h6>
                <button aria-label="Close" class="close" data-dismiss="modal" (click)="modalnotification.hide()"
                    type="button">
                    <span aria-hidden="true"> × </span>
                </button>
            </div>
         
        </div>
    </div>
</div>
